module.exports = __webpack_public_path__ + "static/media/고래산.62d9a536.jpg";